import { useCircleAIShellStore } from "@circle-react-uikit/CircleAIAppShell/store/circleAIShellStore";
import { useLocation } from "@tanstack/react-router";
import { useEffect } from "react";

export const useAutoOpenPanelOnRailbarContent = (
  portalId = "rail-bar-header",
) => {
  const pathname = useLocation({ select: location => location.pathname });
  const setRightSidebarVisible = useCircleAIShellStore(
    s => s.setRightSidebarVisible,
  );

  useEffect(() => {
    let isDisposed = false;
    let observer: MutationObserver | null = null;

    queueMicrotask(() => {
      if (isDisposed) return;

      const el = document.getElementById(portalId);
      if (!el) {
        setRightSidebarVisible(false);
        return;
      }

      const sync = () => setRightSidebarVisible(el.childElementCount > 0);
      sync();

      observer = new MutationObserver(sync);
      observer.observe(el, { childList: true });
    });

    return () => {
      isDisposed = true;
      observer?.disconnect();
    };
  }, [pathname, portalId, setRightSidebarVisible]);
};
